import { AnswerControllers } from './AnswerControllers';
import { DeleteModal, MarkAsSentModal } from '@components/Modals';
import { setIsOpenAnswersDeleteModal, setIsOpenMarkAsSentModal } from '@actions/answersPageAction';
import { translate } from '@utils';
import { MgState } from '@types';
import { AnswersPageState } from '@reducers/initialState/answersPage';
import { useDispatch, useSelector } from 'react-redux';
import { makeDeleteAnswers, makeMarkAnswersAsSent } from '@actions/answerActions';
import { hasPermissionFeature } from '@hooks/hasPermissionFeature';
import { FeaturePermission, PagePermission, PermissionActions } from '../../../../api/enums';

export const AnswerControllersContainer = () => {
  const dispatch = useDispatch();

  const checkedAnswersIds = useSelector<MgState, string[]>(
    ({ answer }) => answer.checkedAnswersIds
  );
  const { isOpenAnswersDeleteModal } = useSelector<MgState, AnswersPageState>(
    ({ answersPage }) => answersPage
  );
  const isDeletingAnswersLoading = useSelector<MgState, boolean>(
    ({ answer }) => answer.isDeletingAnswersLoading
  );

  const hasControllers =
    hasPermissionFeature(
      PagePermission.Answers,
      [FeaturePermission.AnswerTable],
      [PermissionActions.Update]
    ) ||
    hasPermissionFeature(
      PagePermission.Answers,
      [FeaturePermission.AnswerTable],
      [PermissionActions.Remove]
    );

  const handleDeleteAnswers = () => {
    dispatch(makeDeleteAnswers({ answersIds: checkedAnswersIds }));
  };

  const handleMarkAsReadAnswers = () => {
    dispatch(makeMarkAnswersAsSent({ answersIds: checkedAnswersIds }));
  };

  return (
    <>
      {hasControllers && (
        <div className="answers-controller">
          <AnswerControllers />
        </div>
      )}
      <DeleteModal
        title={
          checkedAnswersIds.length > 1
            ? translate('answers-deleted-modal')
            : translate('answer-deleted-modal')
        }
        handleConfirmation={handleDeleteAnswers}
        isDisabledConfirmationButton={isDeletingAnswersLoading}
        open={isOpenAnswersDeleteModal}
        handleCancel={() => dispatch(setIsOpenAnswersDeleteModal(false))}
        contentName="caution_message"
      />
      <MarkAsSentModal
        handleConfirmation={handleMarkAsReadAnswers}
        handleCancel={() => dispatch(setIsOpenMarkAsSentModal(false))}
        contentName="caution_message"
      />
    </>
  );
};
